import React, { useContext } from "react";

import Sharing, { SharingType } from "@/components/Sharing";
import LocaleContext from "@/i18n";

import {
  Col1,
  Col2,
  Col3,
  FlexGrid,
  PrivacyPolicyLink,
  SharingWrap,
  Text,
  TextCopyright,
} from "./styles";

export type FooterProps = {
  participants: number;
  hideParticipantsCount?: boolean;
  leftText?: string;
  onCopyrightClick: () => void;
  hasCopyrights: boolean;
  onShareClick: (type: SharingType) => void;
  icons: IIcons;
  privacyPolicyLink?: string;
};

export const Footer: React.FC<FooterProps> = (
  props: FooterProps
): JSX.Element => {
  const localeContext = useContext(LocaleContext);
  const { translation } = localeContext;

  const {
    participants,
    hideParticipantsCount,
    leftText,
    onShareClick,
    onCopyrightClick,
    icons,
    hasCopyrights,
    privacyPolicyLink,
  } = props;

  return (
    <FlexGrid data-qa="footer">
      <Col1>
        {leftText && <Text>{leftText}</Text>}
        {hasCopyrights && (
          <TextCopyright onClick={onCopyrightClick}>{"©"}</TextCopyright>
        )}
      </Col1>
      <Col2>
        {!hideParticipantsCount && participants > 0 && (
          <Text>
            <span>{participants.toLocaleString()}</span>
            {" " + translation.participants}
          </Text>
        )}
      </Col2>
      <Col3>
        {!privacyPolicyLink && (
          <SharingWrap>
            <Sharing
              icons={icons}
              onShareClick={onShareClick}
              customIconSize={14}
            />
          </SharingWrap>
        )}
        {privacyPolicyLink && (
          <PrivacyPolicyLink href={privacyPolicyLink} target="_blank">
            {translation.dataProtection}
          </PrivacyPolicyLink>
        )}
      </Col3>
    </FlexGrid>
  );
};
